<template>
  <div>

    <b-card
        style="
          border: solid 1px #f5a623;
          padding: 0px;
          width: 100%;
          margin-left: 0rem !important;
          margin-right: 1rem !important;
          
        "
      >
      <template #header>
        <div class="d-flex justify-content-between">

       
        <h6 class="mb-0" style="margin:5px">Service/Vidange</h6>
            <div class="m-2">
              <!-- PROD: https://apil.auto-turki.com -->
                  <!-- LOCAL: http://127.0.0.1:8000 -->
            <a
              
              :href="
                'https://apil.auto-turki.com/api/dynamic_pdf/pdfLibre/' +
                liste_facture[0].id
              "
              target="_blank"
              style="background-color: transparent !important"
            >
              <img src="imp.png" />
            </a>
          </div>
 </div>


        <em>{{ liste_facture[0].service.nom_chouffeur }}</em>

        
      </template>
   
      <b-card-text>
        Matricule:  {{ liste_facture[0].service.matr }}
    </b-card-text>
    <b-card-text>
         {{ liste_facture[0].service.MF }}
    </b-card-text>
    <b-card-text>
        Verification TVA :  
        
      <span v-if="liste_facture[0].service.verif_tva == 0">
       OUI
      </span> 
      <span v-else> NON</span> 
    </b-card-text>
    
    <template #footer>
      <router-link
                    style="color: #4f5d73"
                    :to="{
                      name: 'edit_service',
                      params: { id:  liste_facture[0].service_id },
                    }"
                  >
                  <b-button variant="warning" style="font-size: 15px">
                    Modifer
              </b-button>
                  </router-link>
      
      </template>
    </b-card>
    <b-card
        style="
          border: 1px solid rgb(52 152 219);
          padding: 0px;
          width: 100%;
          margin-left: 0rem !important;
          margin-right: 1rem !important;
          
        "
      >
      <template #header>
        <h6 class="mb-0" style="margin:5px">Facture</h6>
        <em>{{ liste_facture[0].service.nom_chouffeur }}</em>
      </template>
     
      <b-card-text>
        Date:  {{ liste_facture[0].date }}
    </b-card-text>
    <b-card-text>
      Somme :  {{ liste_facture[0].somme }}
    </b-card-text>
    
    <b-card-text>
      TVA :  {{ liste_facture[0].TVA }}
    </b-card-text>

    <b-card-text>
      somme TTC :  {{ liste_facture[0].sommeTTC }}
    </b-card-text>

    <b-card-text>
      Somme en FR :  {{ liste_facture[0].somme_fr }}
    </b-card-text>


    
    <template #footer>
      <router-link
                    style="color: #4f5d73"
                    :to="{
                      name: 'edit_facture',
                      params: { id:  liste_facture[0].id },
                    }"
                  >
                  <b-button variant="info" style="font-size: 15px">
                    Modifer
              </b-button>
                  </router-link>
      </template>
    </b-card>

    <b-card
        style="
          border: 1px solid #4CAF50;
          padding: 0px;
          width: 100%;
          margin-left: 0rem !important;
          margin-right: 1rem !important;
          
        "
      >
      <template #header>
        <h6 class="mb-0" style="margin:5px">Kilometrage</h6>
        <em>{{ liste_facture[0].service.nom_chouffeur }}</em>
      </template>
    <!--   {{ liste_facture }} -->
      <b-card-text>
        Date:  {{ liste_facture[0].kilometrage.date }}
    </b-card-text>
    
    <b-card-text>
      KM :  {{ liste_facture[0].kilometrage.nb_klm }}
    </b-card-text>
    
    


    
    <template #footer>
      <router-link
                    style="color: #4f5d73"
                    :to="{
                      name: 'edit_kilometrage',
                      params: { id:  liste_facture[0].kilometrage.id },
                    }"
                  >
                  <b-button variant="success" style="font-size: 15px">
                    Modifer
              </b-button>
                  </router-link>
      </template>
    </b-card>
  </div>
</template>


<script>
import { apiDomain } from "../../config";
import axios from "axios";
import _ from "lodash";
export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      liste_facture: [],
      
    };
  },

  created(){
this.fetchFacture(this.$route.params.id);
  },

  computed: {
    
  },

  methods: {
   
    
    fetchFacture(id) {
      axios
        .get(
          `${apiDomain}/api/facturation/${id}`
        )
        .then((response) => (this.liste_facture = response.data))
        .catch((error) => console.log(error));
    },
  
  },
};
</script>

<style>
.feed {
  background: #fff;
  height: 106px;
  overflow: scroll;
}
.btdelete {
  padding: 11px 27px !important;
  margin-top: 38px;
  border-radius: 5px;
}
/* 
.md-card img {
  width: 55% !important;
  height: auto;
} */

.en_attente {
  position: absolute;
  background: #c37600;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /* margin-top: -15.6%; */
  margin-top: 1.4% !important;
  height: 34px;
  line-height: 9px;
  border-radius: 15px;
}

nav {
  display: flex;
  justify-content: center;
}

.pagination {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.pagination li {
  margin: 0 1px;
  padding: 11px 6px !important;
  text-decoration: none;
}

.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  background-color: #2a357d !important;

  color: #ffffff !important;
  -webkit-box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
    0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
  box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
    0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
}

.pagination > li > a,
.pagination > li > span {
  color: fff;
  list-style-type: cercle;
  border: 0;
  border-radius: -16px !important;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  padding: 9px;
  margin: 0 3px;
  min-width: 31px;
  height: 31px;
  line-height: 30px;
  color: #999999;
  font-weight: 400;
  font-size: 11px;
  text-transform: uppercase;
  background: transparent;
  /* border-color: blue !important; */
  border-radius: 4px;
  background-color: #e88e08 !important;
  /* border-color: #000; */
  color: #fff !important;
}

.index {
  display: inline-block;
  height: 36px;
  width: 36px;
  line-height: 36px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background-color: #e88e08;
  border-radius: 50% !important;
  text-align: center;
  position: relative;
  z-index: 2;
}

.cer {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  line-height: -10px;
  border-radius: 50%;
  font-size: 50px;
  text-align: center;
  background: rgb(245 175 19);
}
.cer_green {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  line-height: -10px;
  border-radius: 50%;
  font-size: 50px;
  text-align: center;
  background: #0ef717;
}
</style>

